import React, { Component } from "react";

class ShowMore extends React.Component {
	constructor(props) {
		super(props);
		this.state = { more: false };

		this.handleClick = this.handleClick.bind(this);
	}

	componentDidMount() {
		if (this.props.more !== undefined) {
			this.setState({ more: this.props.more });
		}
	}

	componentDidUpdate(props) {
		if (this.props.more !== props.more) {
			this.setState({ more: this.props.more });
		}
	}

	handleClick() {
		this.setState(
			(prevState) => ({
				more: !prevState.more,
			}),
			() => {
				this.props.toggled(this.state.more);
			}
		);
	}

	render() {
		return (
			<div className="separator link my-3" onClick={this.handleClick}>
				<div className="rounded p-1 pointer">
					Show {this.state.more ? "Less" : "More"}
					{this.state.more ? <i className="fas fa-arrow-circle-up i-link px-2"></i> : <i className="fas fa-arrow-circle-down i-link px-2"></i>}
				</div>
			</div>
		);
	}
}
export default ShowMore;
